import eventMessage from 'src/components/event-message';
import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
import { win } from 'src/global';
import { getNodeAttrs, getNodeFieldid, getNodeTitle, getParentNodeTitles, getXpath, isIgnoreDom } from 'src/utils/event';
import safeInvoke from 'src/utils/safe-invoke';

let actionTimer = null;
function onUserAction() {
  if(!actionTimer) {
    win.uba?.getSid(true);
    actionTimer = setTimeout(() => {
      actionTimer = null;
    }, 1000 * 60);
  }
}

function onUserClick(ev: MouseEvent) {
  const t = Date.now();
  let isIgnore = false;
  let areaRate = 0;
  const target = ev.target as HTMLElement;
  try {
    const bodyArea = win.document.body.clientHeight * win.document.body.clientWidth;
    let ctarget = target;
    if(ctarget.shadowRoot) {
      ctarget = target.shadowRoot.activeElement as HTMLElement;
    }
    if(!ctarget) {return;}
    const targetArea = ctarget.clientHeight * ctarget.clientWidth;
    areaRate = targetArea / bodyArea;
    if(areaRate > 0.6) {
      hbLogger.debug('无效点击过滤', target, ev);
      isIgnore = true;
    }
  } catch (err) {}
  if(!isIgnore && !isIgnoreDom(target)) {
    const ptitle = getParentNodeTitles(target);
    const fieldid = getNodeFieldid(target);
    const ntxt = getNodeTitle(ev.target as HTMLElement);
    const xpath = getXpath(ev);
    let cxy = [Math.round(ev.clientX), Math.round(ev.clientY)];
    const pxy = [Math.round(ev.pageX), Math.round(ev.pageY)];
    // 非用户行为触发的事件
    if(!ev.isTrusted) {
      const { x, y } = target.getBoundingClientRect();
      cxy = [Math.round(x), Math.round(y)];
    }

    eventMessage.publish({
      time: t,
      type: EVENT_MSG_TYPE.CLICK,
      data: {
        cx: cxy[0],
        cy: cxy[1],
        px: pxy[0],
        py: pxy[1],
        xpath: xpath.split('>').slice(ntxt ? -2 : -5).join('>'),
        ntxt: ntxt || `点击(${cxy[0]},${cxy[1]})`,
        tits: ptitle.join('#'),
        fieldid: fieldid,
        attrs: {
          isTrustedEv: ev.isTrusted,
          ...getNodeAttrs(ev.target as HTMLElement),
        },
        _fullXpath: xpath,
        _parentNodeTitles: ptitle,
      },
    });
  }
}

/**
 * 用户行为收集
 */
export default () => {
  // keydown scroll touchstart
  ['click', 'keydown', 'scroll', 'touchstart', 'mousemove'].forEach(type => {
    safeInvoke(win, win.addEventListener, type, (ev) => {
      if(document.readyState !== 'loading') {
        onUserAction();
        if(type === 'click') {
          onUserClick(ev as MouseEvent);
        }
      }
    }, true);
  });
}
